<template>
  <div v-if="dataOrigin.state === 'loading'" class="loading"></div>
</template>

<script>
export default {
  props: {
    dataOrigin: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  background: #333;
}
</style>
